import {
  ADD_PLAN,
  DELETE_PLAN,
  GET_PLANS_PROFIT,
  GET_PLAN_FILTER_DATA,
  GET_PLAN_LIST,
  GET_PLAN_PROFILE,
  HIDE_PLAN_LIST_LOADER,
  SET_ERROR_PLAN_PROFILE,
  SET_PLAN_FILTER_DATA,
  SET_PLAN_LIST,
  SET_PLAN_PROFILE,
  SET_PLAN_USER_LIST,
  SHOW_PLAN_LIST_LOADER,
  UPDATE_PLAN_PROFILE,
  SET_PLANS_PROFIT,
  PLANS_PROFIT_LOADER,
  SET_FILTERED_DATE,
  ADD_PLAN_BULK,
  BULK_LOADER,
  DELETE_PLAN_BULK,
  SET_PLAN_GROUPS,
  GET_PLAN_GROUPS,
  DELETE_PLAN_GROUP,
  UPDATE_PLAN_GROUP,
  ADD_PLAN_GROUP,
  GROUP_LOADER,
  GET_PAYOUT_CONDITIONS,
  SET_PAYOUT_CONDITIONS,
  UPDATE_PAYOUT_CONDITIONS,
  DELETE_PAYOUT_CONDITIONS,
  ADD_PAYOUT_CONDITIONS,
  PAYOUT_LOADER,
  ADD_NEW_ROW_OVERVIEW,
  REMOVE_NEW_ROW_OVERVIEW,
  ADD_CUSTOM_PROFIT,
  SET_CUSTOM_PROFIT,
  DELETE_CUSTOM_PROFIT,
  EDIT_CUSTOM_PROFIT,
  CLOSE_EDIT_CUSTOM_PROFIT,
  UPDATE_CUSTOM_PROFIT,
  GET_TOTAL_PROFIT_PLANS,
  SET_TOTAL_PROFIT_PLANS,
  GET_CUSTOM_PROFIT_BY_DAYS,
  PATCH_CUSTOM_PROFIT_BY_DAYS,
  DELETE_CUSTOM_PROFIT_BY_DAYS,
  SET_CUSTOM_PROFIT_BY_DAYS,
  LOADER_CUSTOM_PROFIT_BY_DAYS,
  ADD_CUSTOM_PROFIT_BY_DAYS,
  GET_DATA_BY_DAYS,
  SET_DATA_BY_DAYS,
  LOADER_DATA_BY_DAYS,
  GET_TOTAL_PLAN,
  SET_TOTAL_PLAN,
  GET_TOP_MANAGEMENT_REPORTS_FILTERS,
  SET_TOP_MANAGEMENT_REPORTS_FILTERS,
  GET_PROFIT_PLANS_WIDGET,
  SET_PROFIT_PLANS_WIDGET,
  SET_PROFIT_PLANS_WIDGET_LOADER,
  GET_PROFIT_PLAN_OFFERS,
  SET_PROFIT_PLAN_OFFERS,
  GET_PROFIT_PLAN_EXEC,
  SET_PROFIT_PLAN_EXEC,
  GET_PROFIT_PLAN_MARGIN,
  SET_PROFIT_PLAN_MARGIN,
  GET_PROFIT_PLAN_CUSTOM_FILTER,
  SET_PROFIT_PLAN_CUSTOM_FILTER,
  LOAD_PROFIT_PLAN_CUSTOM_FILTER,
  GET_PROFIT_PLAN_MARGIN_FILTER,
  SET_PROFIT_PLAN_MARGIN_FILTER,
  LOAD_PROFIT_PLAN_MARGIN_FILTER,
  LOADER_TOP_MANAGEMENT_REPORTS_FILTERS,
  GET_AGGREGATED_MANAGERS_PROFIT,
  SET_AGGREGATED_MANAGERS_PROFIT,
  LOADER_AGGREGATED_MANAGERS_PROFIT,
  GET_AGGREGATED_OFFER_PROFIT,
  SET_AGGREGATED_OFFER_PROFIT,
  LOADER_AGGREGATED_OFFER_PROFIT,
  GET_PLANS_PROFIT_STATUS,
  GET_PLANS_HR_OFFER_DETAILED,
  SET_PLANS_HR_OFFER_DETAILED,
  LOADER_PLANS_HR_OFFER_DETAILED
} from "./actionTypes";

export const getTotalProfit = (data) => ({
  type: GET_TOTAL_PROFIT_PLANS,
  payload: data
})

export const setTotalProfit = (data) => ({
  type: SET_TOTAL_PROFIT_PLANS,
  payload: data
})

export const getPlansList = data => ({
  type: GET_PLAN_LIST,
  payload: data,
});

export const getPlanFilterData = () => ({
  type: GET_PLAN_FILTER_DATA,
});

export const setPlanFilterData = payload => ({
  type: SET_PLAN_FILTER_DATA,
  payload,
});

export const setPlansList = payload => ({
  type: SET_PLAN_LIST,
  payload,
});

export const showPlansListLoader = () => ({
  type: SHOW_PLAN_LIST_LOADER,
});

export const hidePlansListLoader = () => ({
  type: HIDE_PLAN_LIST_LOADER,
});

export const addPlan = data => ({
  type: ADD_PLAN,
  payload: data,
});

export const deletePlan = (id, data = {}) => ({
  type: DELETE_PLAN,
  payload: { id, data },
});

export const getPlanProfile = id => ({
  type: GET_PLAN_PROFILE,
  payload: id,
});

export const setPlanProfile = payload => ({
  type: SET_PLAN_PROFILE,
  payload,
});

export const updatePlanProfile = (id, params) => ({
  type: UPDATE_PLAN_PROFILE,
  payload: { id, params },
});

export const setErrorPlanProfile = payload => ({
  type: SET_ERROR_PLAN_PROFILE,
  payload,
});

export const setUsersList = payload => ({
  type: SET_PLAN_USER_LIST,
  payload,
});

export const getPlansProfit = params => ({
  type: GET_PLANS_PROFIT,
  payload: params,
  meta: {
    status: null,
  },
});

export const getPlansProfitStatus = status => ({
  type: GET_PLANS_PROFIT_STATUS,
  payload: status,
});

export const setPlansProfit = data => ({
  type: SET_PLANS_PROFIT,
  payload: data,
});

export const plansProfitLoader = () => ({
  type: PLANS_PROFIT_LOADER,
});

export const setFilteredDate = date => ({
  type: SET_FILTERED_DATE,
  payload: date,
});

export const addPlanBulk = (data, history) => ({
  type: ADD_PLAN_BULK,
  payload: { data, history },
});

export const deletePlansBulk = data => ({
  type: DELETE_PLAN_BULK,
  payload: data,
});

export const bulkLoader = () => ({
  type: BULK_LOADER,
});

export const addPlanGroup = data => ({
  type: ADD_PLAN_GROUP,
  payload: data,
});

export const setPlanGroups = data => ({
  type: SET_PLAN_GROUPS,
  payload: data,
});

export const getPlanGroups = data => ({
  type: GET_PLAN_GROUPS,
  payload: data,
});

export const deletePlanGroups = data => ({
  type: DELETE_PLAN_GROUP,
  payload: data,
});

export const updatePlanGroup = (id, data) => ({
  type: UPDATE_PLAN_GROUP,
  payload: { id, data },
});

export const groupLoader = () => ({
  type: GROUP_LOADER,
});

export const addPayoutCondition = data => ({
  type: ADD_PAYOUT_CONDITIONS,
  payload: data,
});

export const setPayoutCondition = data => ({
  type: SET_PAYOUT_CONDITIONS,
  payload: data,
});

export const getPayoutConditions = data => ({
  type: GET_PAYOUT_CONDITIONS,
  payload: data,
});

export const deletePayoutCondition = data => ({
  type: DELETE_PAYOUT_CONDITIONS,
  payload: data,
});

export const updatePayoutCondition = data => ({
  type: UPDATE_PAYOUT_CONDITIONS,
  payload: data,
});

export const PayoutConditionLoader = () => ({
  type: PAYOUT_LOADER,
});

export const OverviewAddNewRow = (idx, newRow) => ({
  type: ADD_NEW_ROW_OVERVIEW,
  payload: { idx, newRow },
});

export const RemoveOverviewRow = idx => ({
  type: REMOVE_NEW_ROW_OVERVIEW,
  payload: idx,
});

export const AddCustomProfit = (idx, data) => ({
  type: ADD_CUSTOM_PROFIT,
  payload: { idx, data },
});

export const DeleteCustomProfit = id => ({
  type: DELETE_CUSTOM_PROFIT,
  payload: id,
});

export const SetCustomProfit = data => ({
  type: SET_CUSTOM_PROFIT,
  payload: data,
});

export const updateCustomProfit = (data) => ({
  type: UPDATE_CUSTOM_PROFIT,
  payload: data,
})

export const editCustomProfit = index => ({
  type: EDIT_CUSTOM_PROFIT,
  payload: index,
});

export const closeEditCustomProfit = idx => ({
  type: CLOSE_EDIT_CUSTOM_PROFIT,
  payload: idx,
});

export const getDataByDays = (data, type, paramsForFilters) => ({
  type: GET_DATA_BY_DAYS,
  payload: { data, type, paramsForFilters }
});

export const setDataByDays = (data) => ({
  type: SET_DATA_BY_DAYS,
  payload: data,
})

export const setLoaderDataByDays = () => ({
  type: LOADER_DATA_BY_DAYS,
})

export const getCustomProfitByDays = (data) => ({
  type: GET_CUSTOM_PROFIT_BY_DAYS,
  payload: data
});

export const setCustomProfitByDays = (data) => ({
  type: SET_CUSTOM_PROFIT_BY_DAYS,
  payload: data,
})

export const updateCustomProfitByDays = (data) => ({
  type: PATCH_CUSTOM_PROFIT_BY_DAYS,
  payload: data,
})

export const addCustomProfitByDays = (data) => ({
  type: ADD_CUSTOM_PROFIT_BY_DAYS,
  payload: data,
})

export const deleteCustomProfitByDays = (ids) => ({
  type: DELETE_CUSTOM_PROFIT_BY_DAYS,
  payload: ids,
})

export const loaderCustomProfitByDays = () => ({
  type: LOADER_CUSTOM_PROFIT_BY_DAYS,
})

export const getTotalPlan = (data) => ({
  type: GET_TOTAL_PLAN,
  payload: data
}) 

export const setTotalPlan = (data) => ({ 
  type: SET_TOTAL_PLAN,
  payload: data,
})

export const setLoaderManagementReportsFilters = () => ({
  type: LOADER_TOP_MANAGEMENT_REPORTS_FILTERS,
})

export const getTopManagementReportsFilters = (params) => ({
  type: GET_TOP_MANAGEMENT_REPORTS_FILTERS,
  payload: params
})

export const setTopManagementReportsFilters = (data) => ({
  type: SET_TOP_MANAGEMENT_REPORTS_FILTERS,
  payload: data,
})

export const getProfitPlansWidgetData = (params) => ({
  type: GET_PROFIT_PLANS_WIDGET,
  payload: params
})

export const setProfitPlansWidgetData = (data) => ({
  type: SET_PROFIT_PLANS_WIDGET,
  payload: data
})

export const setProfitPlansWidgetLoader = () => ({
  type: SET_PROFIT_PLANS_WIDGET_LOADER,
})

export const getProfitPlanOffers = (data, buyer) => ({
  type: GET_PROFIT_PLAN_OFFERS,
  payload: { data, buyer }
})

export const setProfitPlanOffers = (data) => ({
  type: SET_PROFIT_PLAN_OFFERS,
  payload: data
})

export const getExecPlan = (data) => ({
  type: GET_PROFIT_PLAN_EXEC,
  payload: data
})

export const setExecPlan = (data) => ({
  type: SET_PROFIT_PLAN_EXEC,
  payload: data
})

export const setMarginPlan = (data) => ({
  type: SET_PROFIT_PLAN_MARGIN,
  payload: data
})

export const getMarginPlan = (data) => ({
  type: GET_PROFIT_PLAN_MARGIN,
  payload: data,
})

export const getCustomFilters = (params) => ({
  type: GET_PROFIT_PLAN_CUSTOM_FILTER,
  payload: params
})

export const setCustomFilters = (data) => ({
  type: SET_PROFIT_PLAN_CUSTOM_FILTER,
  payload: data
})

export const setLoadCustomFilters = () => ({
  type: LOAD_PROFIT_PLAN_CUSTOM_FILTER,
})

export const getMarginFilter = (params) => ({
  type: GET_PROFIT_PLAN_MARGIN_FILTER,
  payload: params
})

export const setMarginFilter = (data) => ({
  type: SET_PROFIT_PLAN_MARGIN_FILTER,
  payload: data
})

export const setLoadMarginFilter = () => ({
  type: LOAD_PROFIT_PLAN_MARGIN_FILTER,
})

export const getAggregatedOfferProfit = (params) => ({
  type: GET_AGGREGATED_OFFER_PROFIT,
  payload: params
})

export const setAggregatedOfferProfit = (params) => ({
  type: SET_AGGREGATED_OFFER_PROFIT,
  payload: params
})

export const setLoaderAggregatedOfferProfit = () => ({
  type: LOADER_AGGREGATED_OFFER_PROFIT,
})

export const getAggregatedManagersProfit = (params) => ({
  type: GET_AGGREGATED_MANAGERS_PROFIT,
  payload: params
})

export const setAggregatedManagersProfit = (params) => ({
  type: SET_AGGREGATED_MANAGERS_PROFIT,
  payload: params
})

export const setLoaderAggregatedManagersProfit = () => ({
  type: LOADER_AGGREGATED_MANAGERS_PROFIT,
})

export const getHRDetailedOffers = (params) => ({
  type: GET_PLANS_HR_OFFER_DETAILED,
  payload: params
})

export const setHRDetailedOffers = (params) => ({
  type: SET_PLANS_HR_OFFER_DETAILED,
  payload: params
})

export const LoaderHRDetailedOffers = () => ({
  type: LOADER_PLANS_HR_OFFER_DETAILED,
})